import React, { useState, useEffect, useCallback } from "react";
import styled from "styled-components";
import { Form, Formik } from "formik";
import { useNavigate } from "react-router";
import * as Yup from "yup";

// components
import { TextInput, NumberInput } from "components/form";
import { Button } from "components/common";

// utils
import { api } from "utils";
import { compareObjects } from "utils/object";

// hooks
import { usePrompt } from "hooks/usePrompt";

const CEOSettingsEditForm = ({ info, setLoading }) => {
  const navigate = useNavigate();
  const [formikValues, setFormikValues] = useState({});
  const [dirty, setDirty] = useState(false);

  const initialValues = {
    representName: info?.representName || "",
    mobile: info?.mobile || "",
    email: info?.email || "",
  };

  const validationSchema = Yup.object().shape({
    representName: Yup.string(),
    mobile: Yup.string().matches(
      /01(?:0|1|[6-9])-(\d{3}|\d{4})-\d{4}/,
      "정확한 전화번호를 입력해주세요."
    ),
    email: Yup.string().email("정확한 이메일을 입력해주세요."),
  });

  const updateCeoSettings = async (values) => {
    setLoading(true);
    try {
      await api
        .patch("/partners/manager", {
          seqPartner: info.seqPartner,
          seqPartnerBranch: info.seqPartnerBranch,
          ...values,
        })
        .then(({ data }) => {
          setDirty(false);
          navigate(-1);
          setLoading(false);
        });
    } catch (error) {
      setLoading(false);
      console.error(error);
    }
  };

  const handleSetRef = useCallback(
    (node) => {
      if (node?.values) setFormikValues(node?.values);
    },
    [info]
  );

  useEffect(() => {
    if (!compareObjects(formikValues, initialValues)) {
      setDirty(true);
    } else {
      setDirty(false);
    }
  }, [formikValues]);

  usePrompt(
    "현재 작성중인 내용이 있어요.",
    `이대로 이동하면 입력한 내용이\n저장되지 않아요.\n그래도 페이지에서 나갈까요?`,
    dirty
  );

  return (
    <Formik
      initialValues={initialValues}
      validationSchema={validationSchema}
      validateOnBlur={true}
      validateOnChange={false}
      validateOnMount={false}
      onSubmit={(values) => updateCeoSettings(values)}
      innerRef={(node) => handleSetRef(node)}
    >
      <Form>
        <Wrapper>
          <TextInput
            name="representName"
            label="대표자명"
            placeholder="대표자 성함을 입력해주세요"
          />

          <NumberInput
            inputType="phone"
            name="mobile"
            label="휴대폰 번호"
            placeholder="- 없이 휴대폰 번호를 입력해주세요"
          />

          <TextInput
            name="email"
            label="대표 이메일"
            placeholder="이메일 주소를 입력해주세요"
          />

          <ButtonContainer>
            <Button
              type="submit"
              variant="contained"
              className="square"
              padding="16px"
              text="입력 완료"
            />
          </ButtonContainer>
        </Wrapper>
      </Form>
    </Formik>
  );
};

const Wrapper = styled.div`
  width: 100%;
  height: auto;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 16px 20px;
`;

const ButtonContainer = styled.div`
  position: absolute;
  left: 0;
  right: 0;
  bottom: 40px;
  padding: 0 20px;
  display: flex;
`;

export default CEOSettingsEditForm;
